import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import * as actions from '../actions';
import {browserHistory} from "react-router";

class Message extends Component {

    renderButton = () => {
        if (this.props.messages.button) {
            return(<Button onClick={() => { browserHistory.push(`/${this.props.messages.path}`)}} color="success">{this.props.messages.button}</Button>);
        }
    }

    render() {
        return (
            <div className="message">
                <div className="spacer-lg"></div>
                <div className="spacer-lg"></div>
                <h1>{this.props.messages.msg1}</h1>
                <div className="spacer-lg"></div>
                <h2>{this.props.messages.msg2}</h2>
                <div className="spacer-lg"></div>
                <div>
                    {this.renderButton()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
  return { messages: state.app.messages };
}

export default connect(mapStateToProps, actions)(Message);



// WEBPACK FOOTER //
// ./src/pages/message.js